import { render, staticRenderFns } from "./SetSecondaryPassword.vue?vue&type=template&id=a903e756&scoped=true"
import script from "./SetSecondaryPassword.vue?vue&type=script&lang=js"
export * from "./SetSecondaryPassword.vue?vue&type=script&lang=js"
import style0 from "./SetSecondaryPassword.vue?vue&type=style&index=0&id=a903e756&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a903e756",
  null
  
)

export default component.exports